import React from 'react';
import CustomCheckbox from 'components/CustomCheckbox/CustomCheckbox';

export function TileCheckbox({
  isAllShift,
  label,
  localVerified,
  localAck,
  onRequestDialog,
}: {
  isAllShift: boolean;
  label: string;
  localVerified: boolean;
  localAck: boolean;
  onRequestDialog: (args: { mode: 'verify' | 'ack'; nextVerified: boolean; nextAck: boolean }) => void;
}) {
  if (!isAllShift) return null;
  if (label.trim().toLowerCase() === 'verified in pos') return null;

  const isVerifyLabel = label.toLowerCase().includes('verified');
  const mode: 'verify' | 'ack' = isVerifyLabel ? 'verify' : 'ack';
  const currentChecked = mode === 'verify' ? localVerified : localAck;

  return (
    <div className="audit-verification-checkbox">
      <div
        className="d-flex"
        onClick={() => {
          const nextVerified = mode === 'verify' ? !localVerified : localVerified;
          const nextAck = mode === 'ack' ? !localAck : localAck;
          onRequestDialog({ mode, nextVerified, nextAck });
        }}
      >
        <CustomCheckbox
          className="audit-verification-checkbox-input"
          checked={currentChecked}
          onChange={() => {
            // Handled by div onClick for better hit area
          }}
        />
        <span>{label}</span>
      </div>
    </div>
  );
}

